import React from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

const renderStudentName = (text, record) => (
  <NavLink to={`/student/${record.student}`}>{text}</NavLink>
);

const renderCourseMonth = (text) => (text || text === 0 ? `${text}个月` : '');

const reEnrollColumn = {
  title: '续课',
  dataIndex: 'reEnroll',
  key: 'reEnroll',
  sorter: (a, b) => Number(a.reEnroll || 0) - Number(b.reEnroll || 0),
};

const startDateColumn = {
  title: '开课日期',
  dataIndex: 'startDate',
  key: 'startDate',
  responsive: ['lg'],
  sorter: (a, b) => moment(a.startDate).diff(moment(b.startDate)),
};

const finishDateColumn = {
  title: '结课日期',
  dataIndex: 'finishDate',
  key: 'finishDate',
  responsive: ['lg'],
  sorter: (a, b) => moment(a.finishDate).diff(moment(b.finishDate)),
};

const remainingLessonsColumn = {
  title: '剩余课次',
  dataIndex: 'remainingLessons',
  key: 'remainingLessons',
  responsive: ['lg'],
  render: (text) =>
    text !== '' && text !== null && text !== undefined && Number(text) <= 3
      ? text
      : '',
  sorter: (a, b) =>
    Number(a.remainingLessons || 0) - Number(b.remainingLessons || 0),
};

const enrollDateColumn = {
  title: '报课日期',
  dataIndex: 'enrollDate',
  key: 'enrollDate',
  responsive: ['lg'],
  sorter: (a, b) => moment(a.enrollDate).diff(moment(b.enrollDate)),
};

const courseTypeDisplayNameColumn = {
  title: '课程类别名称',
  dataIndex: 'courseTypeDisplayName',
  key: 'courseTypeDisplayName',
};

const columns_admin = [
  {
    title: '学校id',
    dataIndex: 'student_school_id',
    key: 'student_school_id',
    sorter: (a, b) => a.student_school_id - b.student_school_id,
  },
  {
    title: '学生名字',
    dataIndex: 'studentName',
    key: 'studentName',
    render: renderStudentName,
  },
  courseTypeDisplayNameColumn,
  reEnrollColumn,
  {
    title: '课程有效期',
    dataIndex: 'courseValidity',
    key: 'courseValidity',
    render: renderCourseMonth,
  },
  {
    title: '老师名字',
    dataIndex: 'teacherName',
    key: 'teacherName',
    responsive: ['lg'],
  },
  enrollDateColumn,
  startDateColumn,
  finishDateColumn,
  remainingLessonsColumn,
  {
    title: '报课价格',
    dataIndex: 'total_price',
    key: 'total_price',
    responsive: ['lg'],
    sorter: (a, b) => a.total_price - b.total_price,
  },
  {
    title: '已付金额',
    dataIndex: 'paid',
    key: 'paid',
    sorter: (a, b) => a.balance - b.balance,
  },
  {
    title: '未付金额',
    dataIndex: 'balance',
    key: 'balance',
    sorter: (a, b) => a.balance - b.balance,
  },
  {
    title: '备注',
    dataIndex: 'comments',
    key: 'comments',
    responsive: ['lg'],
    ellipsis: true,
  },
];

const columns_admin_core = [
  {
    title: '学校id',
    dataIndex: 'student_school_id',
    key: 'student_school_id',
    sorter: (a, b) => a.student_school_id - b.student_school_id,
  },
  {
    title: '学生名字',
    dataIndex: 'studentName',
    key: 'studentName',
    render: renderStudentName,
  },
  courseTypeDisplayNameColumn,
  reEnrollColumn,
  {
    title: '课程有效期',
    dataIndex: 'courseValidity',
    key: 'courseValidity',
    render: renderCourseMonth,
  },
  {
    title: '老师名字',
    dataIndex: 'teacherName',
    key: 'teacherName',
    responsive: ['lg'],
  },
  enrollDateColumn,
  startDateColumn,
  finishDateColumn,
  remainingLessonsColumn,
  {
    title: '未付金额',
    dataIndex: 'balance',
    key: 'balance',
    sorter: (a, b) => a.balance - b.balance,
  },
];

const columns_user = [
  {
    title: '学校id',
    dataIndex: 'student_school_id',
    key: 'student_school_id',
    sorter: (a, b) => a.student_school_id - b.student_school_id,
  },
  {
    title: '学生名字',
    dataIndex: 'studentName',
    key: 'studentName',
    render: renderStudentName,
  },
  {
    title: '课程有效期',
    dataIndex: 'courseValidity',
    key: 'courseValidity',
    render: renderCourseMonth,
  },
  courseTypeDisplayNameColumn,
  reEnrollColumn,
  {
    title: '老师名字',
    dataIndex: 'teacherName',
    key: 'teacherName',
    responsive: ['lg'],
  },
  enrollDateColumn,
  startDateColumn,
  finishDateColumn,
  remainingLessonsColumn,
  {
    title: '未付金额',
    dataIndex: 'balance',
    key: 'balance',
    sorter: (a, b) => a.balance - b.balance,
  },
];

export default {
  columns_admin,
  columns_admin_core,
  columns_user,
};
